module.exports = __webpack_public_path__ + "static/img/15132207041.aa7b971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15132207041.jpg
// module id = xQKw
// module chunks = 0